import { createTheme } from '@mui/material/styles';

declare module '@mui/material/styles' {
    interface Palette {
      custom: {
        titleText: string;
        buttonBackground: string;
        selectedListItem: string;
        listItemBackground: string;
        textFieldBackground: string;
      };
    }
  
    interface PaletteOptions {
      custom?: {
        titleText?: string;
        buttonBackground?: string;
        selectedListItem?: string;
        listItemBackground?: string;
        textFieldBackground?: string;
      };
    }
  }

const theme = createTheme({
  palette: {
    custom: {
      titleText: '#515e8e', 
      buttonBackground: '#0062ee', 
      selectedListItem: '#3965f0', 
      listItemBackground: '#fbfbfe', 
      textFieldBackground: 'grey.100',
    },
  },
});

export default theme;